(() => {
  'use strict';

  if (customElements.get('peregy-brand-application')) return;

  class PeregyBrandApplication extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.dialog = this.querySelector('.pba-dialog');
      this.form = this.querySelector('.pba-form');
      this.lastTrigger = null;
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      document.addEventListener('click', (event) => this.handleDocumentClick(event), { signal });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, { signal });
      this.dialog?.addEventListener('close', () => this.afterClose(), { signal });
      this.form?.addEventListener('submit', (event) => this.prepareSubmission(event), { signal });

      this.querySelectorAll('.pba-choice input').forEach((input) => {
        const syncChoiceState = () => {
          input.closest('.pba-choice')?.classList.toggle('is-selected', input.checked);
          if (input.matches('[data-pba-product-type]')) this.clearProductTypeError();
        };
        input.addEventListener('change', syncChoiceState, { signal });
        syncChoiceState();
      });

      const formState = this.querySelector('[data-pba-form-state]')?.dataset.state;
      if (formState === 'success' || formState === 'error') {
        window.requestAnimationFrame(() => this.open());
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      document.documentElement.classList.remove('pba-dialog-open');
      this.dataset.ready = 'false';
    }

    handleDocumentClick(event) {
      const trigger = event.target.closest?.('[data-peregy-brand-apply]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
        return;
      }

      if (event.target.closest?.('[data-pba-close]')) {
        event.preventDefault();
        this.close();
      }
    }

    open(trigger = null) {
      if (!this.dialog || this.dialog.open) return;
      this.lastTrigger = trigger || document.activeElement;
      document.documentElement.classList.add('pba-dialog-open');
      this.dialog.showModal();

      window.requestAnimationFrame(() => {
        const focusTarget = this.querySelector('[data-pba-success], [data-pba-brand], [data-pba-close]');
        focusTarget?.focus({ preventScroll: true });
      });
    }

    close() {
      if (this.dialog?.open) this.dialog.close();
    }

    afterClose() {
      document.documentElement.classList.remove('pba-dialog-open');
      if (this.lastTrigger instanceof HTMLElement && this.lastTrigger.isConnected) {
        this.lastTrigger.focus({ preventScroll: true });
      }
    }

    clearProductTypeError() {
      const error = this.querySelector('[data-pba-types-error]');
      const first = this.querySelector('[data-pba-product-type]');
      if (error) error.hidden = true;
      first?.removeAttribute('aria-invalid');
    }

    prepareSubmission(event) {
      const selectedTypes = Array.from(this.querySelectorAll('[data-pba-product-type]:checked'))
        .map((input) => input.value.trim())
        .filter(Boolean);

      if (!selectedTypes.length) {
        event.preventDefault();
        const error = this.querySelector('[data-pba-types-error]');
        const first = this.querySelector('[data-pba-product-type]');
        if (error) error.hidden = false;
        first?.setAttribute('aria-invalid', 'true');
        first?.focus({ preventScroll: true });
        this.querySelector('[data-pba-product-types]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const value = (selector) => this.querySelector(selector)?.value?.trim() || '';
      const selectedRange = this.querySelector('[data-pba-range]:checked')?.value?.trim() || '';
      const lines = [
        'طلب انضمام علامة تجارية إلى PEREGY',
        '',
        `اسم العلامة التجارية: ${value('[data-pba-brand]')}`,
        `مسؤول التواصل: ${value('[data-pba-contact-name]')}`,
        `رقم الهاتف أو واتساب: ${value('[data-pba-phone]')}`,
        `البريد الإلكتروني: ${value('[data-pba-email]') || 'غير مضاف'}`,
        `رابط العلامة: ${value('[data-pba-link]') || 'غير مضاف'}`,
        `أنواع المنتجات: ${selectedTypes.join('، ')}`,
        `عدد المنتجات المتوقع: ${selectedRange}`,
        '',
        `نبذة إضافية: ${value('[data-pba-notes]') || 'لا توجد ملاحظات إضافية'}`,
      ];

      const message = this.querySelector('[data-pba-message]');
      if (message) message.value = lines.join('\n');

      const submit = this.querySelector('[data-pba-submit]');
      const submitText = this.querySelector('[data-pba-submit-text]');
      if (submit) submit.disabled = true;
      if (submitText && submit) submitText.textContent = submit.dataset.loadingLabel || submit.dataset.defaultLabel;
    }
  }

  customElements.define('peregy-brand-application', PeregyBrandApplication);
})();
